const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  search ({ state, commit, rootState }, params) {
    return rootState.axios.get('/cc/v1frontend/waybill/search', {params})
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/cc/waybill.js